export default __webpack_public_path__ + "media/Social-Work.02042821.svg";